import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client";
import {
    GetCcpHamsStatus,
    GetCcpHamsResponse
} from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { AsyncResult, useAsync } from "./use-async";

export function useCcpHamsStatus({
    cloudId,
    offeringKeys
}: GetCcpHamsStatus): AsyncResult<GetCcpHamsResponse | null> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(
        () =>
            stargateClient.getCcpHamsStatus({
                cloudId,
                offeringKeys
            }),
        []
    );
}
